import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrdersPaymentRequest } from '~/lazy/payments/pages/new-payment/models/ordersPaymentRequest';
import { StatusScreenTypeEnum } from '@qvs/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { StatusScreenComponent } from '~/shared/components/status-screen/status-screen.component';
import { AmountPipe } from '~/shared/pipes/amount.pipe';
import { LocalDatePipe } from '~/shared/pipes/local-date.pipe';
import { AccountIdShortenPipe } from '~/shared/pipes/account-id-shorten.pipe';

@Component({
  selector: 'qvs-validate-payment-order-request-proceed',
  templateUrl: './validate-payment-order-request-proceed.component.html',
  styleUrls: ['./validate-payment-order-request-proceed.component.scss'],
  standalone: true,
  imports: [NgIf, TranslatePipe, StatusScreenComponent, AmountPipe, LocalDatePipe, AccountIdShortenPipe]
})
export class ValidatePaymentOrderRequestProceedComponent {
  @Input() ordersPaymentRequest: OrdersPaymentRequest;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();

  readonly statusScreenType = StatusScreenTypeEnum;

  close() {
    this.closed.emit();
  }
}
